import { LucideIcon } from 'lucide-react';
import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: 'primary' | 'secondary' | 'ghost';
	size?: 'sm' | 'md' | 'lg';
	icon?: LucideIcon;
	iconPosition?: 'left' | 'right';
	children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
	variant = 'primary',
	size = 'md',
	icon: Icon,
	iconPosition = 'left',
	children,
	className = '',
	disabled,
	...props
}) => {
	const baseClasses =
	  'transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none';

	const variantClasses = {
	  primary: 'btn-primary',
	  secondary: 'btn-secondary',
	  ghost: 'btn-ghost',
	};

	const sizeClasses = {
	  sm: 'px-4 py-2 text-small',
	  md: 'px-6 py-3 text-body',
	  lg: 'px-8 py-4 text-hero',
	};

	const iconSize = {
	  sm: 'w-4 h-4',
	  md: 'w-4 h-4',
	  lg: 'w-5 h-5',
	};

	return (
	  <button
	    className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
	    disabled={disabled}
	    {...props}
	  >
	    {Icon && iconPosition === 'left' && <Icon className={iconSize[size]} />}
	    {children}
	    {Icon && iconPosition === 'right' && <Icon className={iconSize[size]} />}
	  </button>
	);
};

export default Button;
